import React from 'react';
import './buttonLink.scss'
import Arrow from "../../../images/icons/agency-arrow.svg"

function ButtonLink(props) {
  const buttonClassName = `redirection-link ${props.extraClass ? `redirection-link__${props.extraClass}`: ''} tag-tracking-capterra`;
  return (
      <a
        href = {props.href}
        onClick={props.onClick}
        className={buttonClassName}
        target={props.target}>
        {props.label}
        {props.arrow && <img src={Arrow} alt=""/>}
        {props.image && <img src={props.image} alt=""/>}
      </a>
  );
}

export default ButtonLink;